module.exports = __webpack_public_path__ + "static/media/PayMoney.c18e90ec.jpg";